import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  async getStatuses({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getStatuses', () =>
      http.get(`dispatch/GetStatuses`)
    )
    commit(types.SET_STATUSES, r.data)
  },
  async getRequests({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getRequests', () =>
      http.get(`dispatch/GetWorkOrders?from=${data.from}&includeScheduledToday=${data.includeScheduled}&appId=${data.appId}`)
    )
    commit(types.SET_REQUESTS, r.data)
  },
  async getTools({ commit, dispatch }, searchOptions, id) {
    const r = await startLoading(dispatch, 'getTools', () =>
      http.get(`dispatch/GetTools`)
    )
    commit(types.SET_TOOLS, r.data)
  },
  async getMasterTechs({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getMasterTechs', () =>
      http.get(`dispatch/getMasterTechs`)
    )
    commit(types.SET_TECHS, r.data)
  },
  async getUserInfo({ commit, dispatch }, username) {
    const r = await startLoading(dispatch, 'getUserInfo', () =>
      http.get(`dispatch/GetUserInfo?username=${username}`)
    )
    commit(types.SET_USERINFO, r.data)
  },
  async updateWorkOrder({ commit, state, dispatch }, data) {
    await startLoading(dispatch, 'updateWorkOrder', () =>
      http.post(`dispatch/UpdateWorkOrder`, data)
    )
  },
  async updateUserStatus({ commit, state, dispatch }, data) {
    await startLoading(dispatch, 'updateUserStatus', () =>
      http.post(`dispatch/UpdateUserStatus?userID=${data.userId}&statusID=${data.statusId}`)
    )
  },
  async updateToolStatus({ commit, state, dispatch }, data) {
    await startLoading(dispatch, 'updateToolStatus', () =>
      http.post(`dispatch/UpdateToolStatus?toolID=${data.toolId}&statusID=${data.statusId}`)
    )
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/actions.js